<script setup lang="ts">
import type { TwoColumnTable } from 'types/blocks';
import type { ComponentStyles } from 'types/index';

const props = defineProps<{
  data: TwoColumnTable;
  componentStyles: ComponentStyles;
}>();
const dynamicBorderColor = computed(() => {
  if (
    props.componentStyles.bgColor === 'bg-white' ||
    props.componentStyles.bgColor === 'bg-secondary' ||
    props.componentStyles.bgColor === 'bg-gray-10'
  ) {
    return 'border-primary';
  } else if (props.componentStyles.bgColor === 'bg-black text-white') {
    return 'border-white';
  } else {
    return 'border-black';
  }
});
</script>

<template>
  <BaseComponentWrapper
    v-if="data"
    :component-styles="componentStyles"
  >
    <div class="container flex flex-col gap-5">
      <h2 v-if="data.headline">
        {{ data?.headline }}
      </h2>
      <BaseRte
        v-if="data.description"
        :content="data?.description"
      />
      <table
        v-if="data.tableRows"
        class="w-full"
      >
        <thead class="sr-only">
          <tr>
            <th class="p-2 text-left">{{ data.leftColumnHeader }}</th>
            <th class="p-2 text-left">{{ data.rightColumnHeader }}</th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(row, index) in data.tableRows"
            :key="`table-row-${index}`"
            class="p-2"
          >
            <td
              v-if="row.content.leftColumn"
              class="border p-2"
              :class="props.data.toggleBorderColor ? dynamicBorderColor : 'border-transparent'"
            >
              <BaseRte :content="row.content?.leftColumn" />
            </td>

            <td
              v-if="row.content.rightColumn"
              class="w-1/6 border p-2"
              :class="props.data.toggleBorderColor ? dynamicBorderColor : 'border-transparent'"
            >
              <BaseRte :content="row.content?.rightColumn" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </BaseComponentWrapper>
</template>
